/* Hiho jQuery guard
   The theme loads jQuery (and its plugins: Flickity, zoom, Fancybox...) at the end of
   the page. Some apps load their own copy of jQuery; if theirs finishes after the
   theme's, it replaces window.jQuery / window.$ and the theme's plugins disappear
   ("... .zoom is not a function", "... .flickity is not a function"), which stops
   product galleries from loading. This keeps every plugin available on whichever
   jQuery copy is current. Load straight after vendors.js. */
(function () {
  var themeJQ = window.jQuery;
  if (!themeJQ || !themeJQ.fn) {
    return;
  }

  function copyMissing(from, to) {
    if (!from || !to || from === to) {
      return;
    }
    // Plugin methods, e.g. $.fn.zoom, $.fn.flickity
    if (from.fn && to.fn) {
      Object.keys(from.fn).forEach(function (key) {
        if (typeof from.fn[key] === 'function' && typeof to.fn[key] !== 'function') {
          to.fn[key] = from.fn[key];
        }
      });
    }
    // Static helpers, e.g. $.fancybox
    Object.keys(from).forEach(function (key) {
      if (!(key in to)) {
        to[key] = from[key];
      }
    });
  }

  ['jQuery', '$'].forEach(function (name) {
    var current = window[name];
    try {
      Object.defineProperty(window, name, {
        configurable: true,
        enumerable: true,
        get: function () {
          return current;
        },
        set: function (value) {
          if (value && value !== current && typeof value === 'function' && value.fn) {
            copyMissing(current, value);
            copyMissing(themeJQ, value);
          }
          current = value;
        }
      });
    } catch (e) {
      /* leave window.jQuery as it is if the browser refuses */
    }
  });
})();
